(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/slide-in-container/assets/javascripts/views/slide-in-container-header.js') >= 0) return;  svs.modules.push('/components/app/slide-in-container/assets/javascripts/views/slide-in-container-header.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.app.slide_in_container.views.SlideInContainerHeader = Backbone.Marionette.View.extend({
    className: 'slide-in-container-header f-prominent f-bold',

    template: function(data) {
      return svs.app.slide_in_container.templates.slide_in_container_header(data);
    },

    ui: {
      closeBtn: '.js-slide-container-close'
    },

    triggers: {
      'click @ui.closeBtn': 'toggle:close'
    }
  });
})(Backbone, svs);

 })(window);